module.exports = __webpack_public_path__ + "media/knocking_door.e6b5cdc4.mp3";